import { createContext } from 'react';
var HighlightContext = createContext({ highlight: false, match: '' });
export default HighlightContext;
//# sourceMappingURL=HighlightContext.js.map